'use client';

import { createContext, type ReactNode, useContext, useEffect } from 'react';
import { useStore } from 'zustand';
import { bootstrapStoreFromUrlParams } from './strategies/bootstrap-store-from-url-params';
import { BootstrapServices } from './services/BootstrapServices';
import { _authStore } from './store/auth-store';
import { type AuthStore } from './store/auth-store.types';
import { BootstrapStrategiesServices } from './strategies/BootstrapStrategiesServices';

export const AuthContext = createContext(_authStore);

export type AuthContextProviderProps = {
  children: ReactNode;
};

export const AuthContextProvider = ({ children }: AuthContextProviderProps) => {
  useEffect(() => {
    bootstrapStoreFromUrlParams();
  }, []);

  return (
    <AuthContext.Provider value={_authStore}>
      <BootstrapStrategiesServices />
      <BootstrapServices />
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = <T,>(selector: (store: AuthStore) => T): T => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error(`useAuth must be used within AuthContext`);
  }

  return useStore(context, selector);
};
